import FlexBox from "@/components/layout/FlexBox"
import React from "react"
import {useTheme} from "@/hooks/useTheme"

export const MobileLayout = ({header, children, footer, contentMaxWidth = '420px'}) => {
  const {logo, logoWidth, logoHeight} = useTheme()
  return (
    <FlexBox style={{
      minHeight: "100vh",
    }} column>
      <FlexBox marginTop centered>
        <FlexBox style={{
          width: '100%',
          maxWidth: contentMaxWidth,
        }}>
          <FlexBox style={{
            maxWidth: logoWidth || '140px',
            height: logoHeight || '40px',
            marginLeft: '5px'
          }}>
            <img
              src={logo}
              style={{
                height: '100%',
                width: 'auto',
                objectFit: 'contain'
              }}
              alt="Partner logo"
            />
          </FlexBox>
        </FlexBox>
      </FlexBox>
      {header}
      <FlexBox centered flexGrow style={{alignItems: 'flex-start'}}>
        <FlexBox
          column
          flexGrow
          style={{
            width: '100%',
            maxWidth: contentMaxWidth,
            padding: '0 20px'
          }}
        >
          {children}
        </FlexBox>
      </FlexBox>
      {footer}
    </FlexBox>
  )
}

